import rsa from 'js-crypto-rsa';

const rsaPublicKey = {
  "e": "AQAB",
  "kty": "RSA",
  "n": "ssBW7MtIUSAJbpivxCLQ1Q8rEuwq82w-03WjL2F1qYpi4XuPTOs5cQajI79uW4f5dYYz9grQIVJfd32YSvqe2iTiEZv51qZdJEp7pc2HH_XwWNDn678i4yGc-_14XuYoTymHb93tgt4gG_PgAQoTR-djsIfuacA5ibMt3PCvx3X_r2y2D1hpTf5rehijMJMvGFNBPMr-oJA4LDhRvAnGKtEe7pOcwAp5O64OLaWAO6QRwjgR-R-als5YuOXDVPi0PCRIK6L65UboPi2J3A6rRpaz6A22hXWh9o38pfEUlk2ZvLzyKnkBu0TfdTtxRiOqt8WCoT4Vqzj1_CCdznFb0w"
};

export const MemberLoginUtils = {
  
  encryptPassword: (rawpassword:string) =>
    rsa.encrypt(new TextEncoder().encode(rawpassword), rsaPublicKey, 'SHA-256')
      .then(encrypted => Array.from(encrypted).map(b => b.toString(16).padStart(2, '0')).join(''))
}



